import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState, ListView } from 'model/state';
import { Dispatch } from 'redux';
import { AddLocationModal } from 'components';
import { selectIsSubmitting, selectCountryList, selectRegionList, selectTimezoneList, selectUserLocations, selectAccountId, selectCurrentLocation, selectUserId } from 'selectors';
import { Country, Region, Location, LocationType } from 'model';
import { fetchRegionList, fetchTimezoneList, createLocation, editLocation, fetchUserLocations } from 'actions';
import { Timezone } from 'model/Timezone';

type SelectedValues = {
  isSubmitting: boolean,
  countries?: Country[],
  regions?: Region[],
  timezones?: Timezone[],
  userLocations: ListView<Location>,
  accountId?: string,
  currentLocation: Location | null,
  userId?: string | null,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  isSubmitting: selectIsSubmitting(),
  countries: selectCountryList(),
  regions: selectRegionList(),
  timezones: selectTimezoneList(),
  userLocations: selectUserLocations(),
  accountId: selectAccountId(),
  currentLocation: selectCurrentLocation(),
  userId: selectUserId(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchRegionList: (countryId: string) => dispatch(fetchRegionList(countryId)),
  fetchTimezoneList: (countryId: string, stateId: string | null) => dispatch(fetchTimezoneList(countryId, stateId)),
  crateLocation: (location: Location) => dispatch(createLocation(location)),
  editLocation: (location: Location) => dispatch(editLocation(location)),
  fetchUserLocations: (userId: string, types: LocationType[], page: number, search?: string) => dispatch(fetchUserLocations(userId, types, page, search)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddLocationModal);
